<template>
  <div>

    <input type="search" v-model="search_value" placeholder="Search"  style="margin-bottom:24px;" />

    <div class="admin__tabs"  v-if="search_value.length < 3">
      <input class="admin__tab-radio" name="approval_state" type="radio" id="approval_state_not_set" :value="APPROVAL_NOT_SET" v-model="approval_state" />
      <label class="admin__tab-label" for="approval_state_not_set">Not Set</label>
      <input class="admin__tab-radio" name="approval_state" type="radio" id="approval_state_approved" :value="APPROVAL_APPROVED" v-model="approval_state" />
      <label class="admin__tab-label" for="approval_state_approved">Approved</label>
      <input class="admin__tab-radio" name="approval_state" type="radio" id="approval_state_maybe" :value="APPROVAL_MAYBE" v-model="approval_state" />
      <label class="admin__tab-label" for="approval_state_maybe">Maybe</label>
      <input class="admin__tab-radio" name="approval_state" type="radio" id="approval_state_rejected" :value="APPROVAL_REJECTED" v-model="approval_state" />
      <label class="admin__tab-label" for="approval_state_rejected">Rejected</label>
      <input class="admin__tab-radio" name="approval_state" type="radio" id="approval_state_kids" :value="APPROVAL_KIDS" v-model="approval_state" />
      <label class="admin__tab-label" for="approval_state_kids">Kids</label>
    </div>

    <table class="admin__table">
      <tr v-for="(site, index) in potential_sites" :key="index">

        <td>{{index}}</td>
       <!-- <td><router-link :to="admin_site_path(site.document_id)">{{ site.document_id }}</router-link></td> -->
        <td><a :href="`https://${site.domain_url}`" target="_blank">https://{{ site.domain }}</a></td>
        <td>{{ site.handle }}</td>
        <td>{{ site.approval_state == APPROVAL_APPROVED ? site.weighting : site.alexa_rank }}</td>
        <td style="white-space:nowrap;">{{ site.approval_state_name }}</td>
        <td><a @click="setApprovalState(index, site, APPROVAL_APPROVED)">Approve</a></td>
        <td><a @click="setApprovalState(index, site, APPROVAL_MAYBE)">Maybe</a></td>
        <td><a @click="setApprovalState(index, site, APPROVAL_REJECTED)">Reject</a></td>
        <td><a @click="setApprovalState(index, site, APPROVAL_KIDS)">Kids</a></td>
        <td><router-link :to="`/admin/sites/${site.document_id}/edit`">Edit</router-link></td>
        <td><router-link :to="`/admin/sites/${site.document_id}/products`">Products</router-link></td>
      </tr>
    </table>

     <div style="margin-top: 20px;">
       <a class="admin__link" @click="nextPage__clicked">Next Page</a>
     </div>

     <popup v-if="selected_potential_site" @close="selected_potential_site = null">
       <h3>Approve Site</h3>
       <table class="admin__table">
         <tr><td class="admin__table-heading">Shopify Name</td><td>{{ selected_potential_site.shopify_name }}</td></tr>
         <tr><td class="admin__table-heading">Shopify Domain</td><td>{{ selected_potential_site.shopify_domain }}</td></tr>
         <tr><td class="admin__table-heading">API URL</td><td><a :href="selected_potential_site.api_url" target="_blank">{{ selected_potential_site.api_url }}</a></td></tr>
         <tr><td class="admin__table-heading">Ships To Australia</td><td>{{ selected_potential_site.ships_to_australia }}</td></tr>
         <tr><td class="admin__table-heading">Ships To USA</td><td>{{ selected_potential_site.ships_to_usa }}</td></tr>
         <tr><td class="admin__table-heading">Money Format</td><td>{{ selected_potential_site.shopify_money_format }}</td></tr>
         <tr><td class="admin__table-heading">Name</td><td><input type="text" v-model="selected_potential_site.name" /></td></tr>
         <tr><td class="admin__table-heading">Handle</td><td><input type="text" v-model="selected_potential_site.handle" /></td></tr>
         <tr><td class="admin__table-heading">Currency Symbol</td><td><input type="text" v-model="selected_potential_site.currency_symbol" /></td></tr>
       </table>
       <br />
       <a class="button" @click="approveSelectedSite">Approve Site</a>
     </popup>

  </div>
</template>

<script>
import Popup from '../../../components/admin/popup'
import PotentialShopifySite from '../../../models/PotentialShopifySite'

export default {
  components: {
    Popup
  },
  data(){
    return{
      APPROVAL_NOT_SET: PotentialShopifySite.ApprovalState.NOT_SET,
      APPROVAL_REJECTED: PotentialShopifySite.ApprovalState.REJECTED,
      APPROVAL_MAYBE: PotentialShopifySite.ApprovalState.MAYBE,
      APPROVAL_APPROVED: PotentialShopifySite.ApprovalState.APPROVED,
      APPROVAL_KIDS: PotentialShopifySite.ApprovalState.KIDS,
      approval_state: PotentialShopifySite.ApprovalState.APPROVED,
      search_value: "",
      potential_sites: [],
      selected_potential_site: null,
    }
  },
  async mounted(){
    await this.loadSites();
  },
  computed:{

  },
  methods: {
    async loadSites(){
      if(this.search_value.length > 2){
        this.potential_sites = await PotentialShopifySite.startWithText('domain', this.search_value.trim());
      }else{
        this.potential_sites = await PotentialShopifySite.approvalPage(this.approval_state);
      }
    },
    async nextPage__clicked(event){
      this.potential_sites = await PotentialShopifySite.approvalPage(this.approval_state, this.lastSiteAlexaRank());
    },
    lastSiteAlexaRank(){
      return this.potential_sites[this.potential_sites.length - 1].alexa_rank;
    },
    async setApprovalState(index, site, approval_state){
      if(approval_state === PotentialShopifySite.ApprovalState.APPROVED){
        await this.fetchShopifyData(site);

      }else {
        site.approval_state = approval_state;
        await site.save();
      }

      if(approval_state !== this.approval_state){
        this.potential_sites.splice(index, 1);
      }
    },
    async fetchShopifyData(site){
      let url = "https://" + site.domain.replace("http://", "").replace("https://", "") + "/meta.json";
      console.log("approve site", url, site);
      let response = await fetch(url).then(response => response.json());
      console.log("response", response)
      await site.updateShopifyMetaData(response);
      this.selected_potential_site = site;
      this.selected_potential_site.name = site.shopify_name;
      this.selected_potential_site.handle = site.shopify_name.toLowerCase().replace(" ", "-");
      console.log("updated", site);
    },
    rejectSite(site){

    },
    async approveSelectedSite(){
      try {
        await this.selected_potential_site.approveSite();
        this.selected_potential_site = null;
        alert("Site Approved");
      } catch (error) {
        alert(error);
      }
    }
  },
  watch:{
    async approval_state(value){
      await this.loadSites();
    },
    async search_value(value){
      await this.loadSites();
    }
  }
}
</script>
